<template>
<div class="chapter">
<div class="inner_page">
<blockquote class="sink">
<p class="center sink"><em>for ln &amp; smy &amp; ncb</em></p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?d3b3160e